export enum TeamSizeTypeOptions {
	oneToTen = "oneToTen",
	tenToTwentyFive = "tenToTwentyFive",
	twentyFiveToFifty = "twentyFiveToFifty",
	fiftyToHundred = "fiftyToHundred",
	overHundred = "overHundred",
}
